import {jsx as _jsx} from "react/jsx-runtime";import * as Tooltip from '@radix-ui/react-tooltip'
import {generateHTML, generateJSON} from '@tiptap/core'
import {BrowserRouter as Router} from 'react-router-dom'
import Action from './components/Action/Action'
import AtmosphereProvider from './components/AtmosphereProvider/AtmosphereProvider'
import {TipTapProvider} from './components/TipTapProvider'
import {serverTipTapExtensions} from './shared/tiptap/serverTipTapExtensions'
import './styles/theme/global.css'
export default function Root() {
  return (
    _jsx(AtmosphereProvider, { children: 
      _jsx(Router, { children: 
        _jsx(Tooltip.Provider, { children: 
          _jsx(TipTapProvider, {
            generateHTML: generateHTML,
            generateJSON: generateJSON,
            extensions: serverTipTapExtensions,
 children: 
            _jsx(Action, {} )
          })
        })
      })
    })
  )
}
